import { ROUTES } from '@/lib/routes';
import { WhatsAppUtils } from '@/shared/utils';
import { AlertTriangle, LogOut, CreditCard, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/backend/context/auth-management';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function BlockedScreen() {
  const navigate = useNavigate();
  const { logout, adminSettings, profile } = useAuth();

  const isSuspended = adminSettings?.accountStatus === 'suspended';
  const description = isSuspended 
    ? 'Tu acceso ha sido restringido por el equipo de administración. Contacta a soporte para más detalles.'
    : 'Tu suscripción ha llegado a su fin. Renueva tu plan ahora para seguir disfrutando de todos los beneficios de tufirma.pro';

  const handleSupport = () => {
    const businessName = profile?.public?.branding?.name || 'Mi Negocio';
    const reason = isSuspended ? 'cuenta suspendida' : 'membresía expirada';
    WhatsAppUtils.redirectToContact(`Hola, necesito ayuda con mi ${reason}. Negocio: ${businessName}`);
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-zinc-950 p-6 text-white text-center">
      <div className="relative mb-10">
        <div className="absolute inset-0 animate-pulse rounded-full bg-rose-500/20 blur-3xl" />
        <div className="relative rounded-[2.5rem] bg-rose-500/10 p-8 ring-1 ring-rose-500/50">
          <AlertTriangle className="h-16 w-16 text-rose-500" />
        </div>
      </div>

      <h1 className="mb-4 text-4xl font-black italic tracking-tighter uppercase">
        {isSuspended ? 'Cuenta' : 'Membresía'} <span className="text-rose-500">{isSuspended ? 'Suspendida' : 'Expirada'}</span>
      </h1>
      
      <p className="max-w-xs text-sm font-bold leading-relaxed text-zinc-400 opacity-80 mb-12">
        {description}
      </p>

      <div className="grid w-full max-w-sm gap-4">
        {!isSuspended && (
          <Button
            onClick={() => navigate(ROUTES.SETTINGS.PAYMENTS_FROM_PLAN)}
            className="h-20 w-full rounded-[2rem] bg-white text-lg font-black tracking-widest text-zinc-950 uppercase hover:bg-zinc-100 shadow-2xl shadow-white/10"
          >
            <CreditCard className="mr-3 h-6 w-6" />
            Renovar Plan
          </Button>
        )}

        <Button
          variant="outline"
          onClick={handleSupport}
          className={cn(
            "w-full rounded-[1.8rem] border-zinc-800 bg-zinc-900/50 text-white uppercase hover:bg-zinc-800",
            isSuspended ? "h-20 text-lg font-black tracking-widest shadow-2xl" : "h-16 text-[11px] font-black tracking-[0.2em]"
          )}
        >
          <MessageCircle className="mr-2 h-5 w-5 text-emerald-400" />
          Soporte Técnico
        </Button>

        <button
          onClick={() => logout()}
          className="mt-4 flex items-center justify-center gap-2 text-[10px] font-black tracking-[0.3em] text-zinc-500 uppercase transition-all hover:text-rose-400"
        >
          <LogOut className="h-4 w-4" />
          Cerrar Sesión
        </button>
      </div>

      <div className="absolute bottom-10 opacity-20">
        <img src="/logo.svg" alt="TuNomina" className="h-8 grayscale" />
      </div>
    </div>
  );
}
